import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function PainelUsuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [deletandoId, setDeletandoId] = useState(null);
  const [busca, setBusca] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 10;

  const BASE_URL = "https://cashbet-backend.onrender.com";

  useEffect(() => {
    fetchUsuarios();
  }, []);

  useEffect(() => {
    setPaginaAtual(1);  // Resetar pra página 1 quando a busca muda
  }, [busca]);

  const fetchUsuarios = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/admin/usuarios`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      console.log("DEBUG usuarios ->", response.data);

      let usuariosBrutos = [];

      if (Array.isArray(response.data)) {
        usuariosBrutos = response.data;
      } else if (Array.isArray(response.data.usuarios)) {
        usuariosBrutos = response.data.usuarios;
      } else {
        console.warn("Nenhum usuário encontrado ou formato inesperado.");
      }

      const sanitizedData = usuariosBrutos.map(user => ({
        userId: user.userId || "nulo",
        nome: user.nome || "nulo",
        email: user.email || "nulo",
        trackingId: user.trackingId || "nulo",
        saldo: typeof user.saldo === "number" ? user.saldo : 0,
        sourceMaisRecente: user.sourceMaisRecente || "nulo",
        sourceAfiliadoMaisRecente: user.sourceAfiliadoMaisRecente || "nulo",
        transacoesRecentes: Array.isArray(user.transacoesRecentes)
          ? user.transacoesRecentes
          : []
      }));

      setUsuarios(sanitizedData);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
      toast.error("Erro ao buscar usuários.");
    } finally {
      setLoading(false);
    }
  };

  const excluirUsuario = async (userId) => {
    if (!window.confirm("Tem certeza que deseja excluir este usuário? Esta ação é irreversível.")) return;

    setDeletandoId(userId);
    try {
      await axios.delete(`${BASE_URL}/api/admin/usuarios/${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
      toast.success("Usuário excluído com sucesso!");
      setUsuarios(prev => prev.filter(u => u.userId !== userId));
    } catch (error) {
      console.error("Erro ao excluir usuário:", error);
      toast.error("Erro ao excluir usuário.");
    } finally {
      setDeletandoId(null);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </div>
    );
  }

  const usuariosFiltrados = usuarios.filter(user =>
    (user.nome && user.nome.toLowerCase().includes(busca.toLowerCase())) ||
    (user.email && user.email.toLowerCase().includes(busca.toLowerCase()))
  );

  const totalPaginas = Math.ceil(usuariosFiltrados.length / itensPorPagina);
  const indexUltimoItem = paginaAtual * itensPorPagina;
  const indexPrimeiroItem = indexUltimoItem - itensPorPagina;
  const usuariosPaginados = usuariosFiltrados.slice(indexPrimeiroItem, indexUltimoItem);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Usuários cadastrados</h2>

      <input
        type="text"
        placeholder="Buscar usuário por nome ou email..."
        value={busca}
        onChange={(e) => setBusca(e.target.value)}
        className="border p-2 rounded w-full mb-4"
      />

      <table className="min-w-full bg-white border border-gray-200 shadow-sm">
        <thead>
          <tr className="bg-gray-100 text-left">
            <th className="p-2">Nome</th>
            <th className="p-2">E-mail</th>
            <th className="p-2">Tracking ID</th>
            <th className="p-2">Saldo</th>
            <th className="p-2">Source</th>
            <th className="p-2">Afiliado</th>
            <th className="p-2">Ações</th>
          </tr>
        </thead>
        <tbody>
          {usuariosPaginados.map(user => (
            <tr key={user.userId} className="border-t border-gray-200">
              <td className="p-2">{user.nome}</td>
              <td className="p-2">{user.email}</td>
              <td className="p-2 text-sm">{user.trackingId}</td>
              <td className="p-2">R$ {parseFloat(user.saldo).toFixed(2)}</td>
              <td className="p-2 text-xs">{user.sourceMaisRecente || "-"}</td>
              <td className="p-2 text-xs">{user.sourceAfiliadoMaisRecente || "-"}</td>
              <td className="p-2">
                <button
                  onClick={() => setUsuarioSelecionado(user)}
                  className="mr-2 px-3 py-1 bg-blue-500 text-white rounded"
                >
                  Ver
                </button>
                <button
                  onClick={() => excluirUsuario(user.userId)}
                  className="px-3 py-1 bg-red-600 text-white rounded disabled:opacity-50"
                  disabled={deletandoId === user.userId}
                >
                  {deletandoId === user.userId ? 'Excluindo...' : 'Excluir'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Paginação */}
      {totalPaginas > 1 && (
        <div className="flex justify-between items-center mt-4">
          <button
            onClick={() => setPaginaAtual(prev => Math.max(prev - 1, 1))}
            disabled={paginaAtual === 1}
            className="px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-50"
          >
            Anterior
          </button>
          <span className="text-sm">
            Página {paginaAtual} de {totalPaginas}
          </span>
          <button
            onClick={() => setPaginaAtual(prev => Math.min(prev + 1, totalPaginas))}
            disabled={paginaAtual === totalPaginas}
            className="px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-50"
          >
            Próxima
          </button>
        </div>
      )}

      {/* Modal */}
      {usuarioSelecionado && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
          <div className="bg-white p-6 rounded-md max-w-3xl w-full shadow-lg">
            <h3 className="text-xl font-semibold mb-4">
              Transações de {usuarioSelecionado.nome}
            </h3>
            <div className="max-h-96 overflow-y-auto">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2">Data</th>
                    <th className="p-2">Tipo</th>
                    <th className="p-2">Status</th>
                    <th className="p-2">Valor</th>
                    <th className="p-2">CashbackID</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(usuarioSelecionado.transacoesRecentes) && usuarioSelecionado.transacoesRecentes.length > 0 ? (
                    usuarioSelecionado.transacoesRecentes.map((tx, i) => (
                      <tr key={i} className="border-t">
                        <td className="p-2">{tx.data || "-"}</td>
                        <td className="p-2">{tx.tipo}</td>
                        <td className="p-2">{tx.status}</td>
                        <td className="p-2">R$ {parseFloat(tx.valor).toFixed(2)}</td>
                        <td className="p-2">{tx.cashbackId || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="p-4 text-center text-gray-500">
                        Nenhuma transação recente.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="text-right mt-4">
              <button
                onClick={() => setUsuarioSelecionado(null)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
}
